export default "/static/dashboard/build/app/img/v2/2042c25c82a6e228540dcb515d19ea0e.png";